import styled from "@mui/material/styles/styled";
import Typography from "@mui/material/Typography";

import UpsellHeroBg from "@app/analytics/assets/auth/upsell_hero_bg.png";

import Stack from "@rui/Stack";
import { Img } from "@rui/styles";

export const ParentContainer = styled(Stack)(({ theme }) => ({
  width: "100%",
  flexDirection: "column",
  alignItems: "stretch",
  minHeight: "100vh",
  [theme.breakpoints.up("md")]: {
    flexDirection: "row",
  },
}));

const AuthColumn = styled(Stack)(({ theme }) => ({
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  [theme.breakpoints.up("md")]: {
    flexGrow: 1,
    alignItems: "center",
    minHeight: "100vh",
    maxHeight: "100vh",
  },
}));

export const RightColumn = styled(AuthColumn)(({ theme }) => ({
  flex: 1,
  flexBasis: "50%",
  [theme.breakpoints.down("md")]: {
    display: "none",
  },
  [theme.breakpoints.up("md")]: {
    justifyContent: "flex-start",
  },
}));

export const LeftColumn = styled(AuthColumn)(({ theme }) => ({
  backgroundColor: "#FFF",
  flexBasis: "50%",
  [theme.breakpoints.down("sm")]: {
    justifyContent: "flex-start",
  },
  [theme.breakpoints.down("md")]: {
    flex: 1,
    minHeight: "100%",
  },
  [theme.breakpoints.up("md")]: {
    justifyContent: "flex-end",
  },
}));

export const FormColumn = styled(AuthColumn)({
  maxWidth: "746px",
  justifyContent: "center",
});

export const WideColumnContent = styled(AuthColumn)({
  maxWidth: "100%",
  justifyContent: "center",
  flex: 1,
});

export const FormColumnContent = styled(Stack)(({ theme }) => ({
  flex: 1,
  minHeight: "420px",
  maxWidth: "490px",
  padding: "20px",
  overflow: "hidden",
  [theme.breakpoints.up("sm")]: {
    padding: "40px",
  },
}));

export const CarouselPanel = styled(Stack)(({ theme }) => ({
  height: "100%",
  maxHeight: "100%",
  overflow: "hidden",
  backgroundColor: theme.palette.shades.primary[500],
  flex: 1,
  width: "100%",
}));

export const CarouselStepperOuterContainer = styled(Stack)(({ theme }) => ({
  padding: "40px",
  width: "100%",
  [theme.breakpoints.up("md")]: {
    marginBottom: "60px",
    paddingTop: "60px",
  },
  "@media (max-height: 800px)": {
    padding: "20px",
    marginBottom: 0,
  },
}));

export const CarouselStepperInnerContainer = styled(Stack)({
  height: "50px",
});

export const CarouselPanelTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  fontSize: "1.75rem",
  color: "#fff",
  textAlign: "center",
  marginTop: "20px",
  [theme.breakpoints.up("md")]: {
    marginTop: "40px",
  },
}));

export const VideoCarouselPanel = styled(Stack)({
  flexShrink: 1,
  height: "100%",
  overflow: "hidden",
  position: "relative",
  width: "100%",
});

export const ImageContainer = styled(Stack)({
  justifyContent: "flex-start",
  width: "100%",
  height: "100%",
  maxHeight: "100%",
});

export const ImageCarouselPanel = styled(Stack)(({ theme }) => ({
  overflow: "hidden",
  position: "relative",
  flexShrink: 1,
  [theme.breakpoints.up("md")]: {
    minHeight: "694px",
  },
}));

export const ImageShim = styled(Img)({
  maxWidth: "100%",
  opacity: 0,
});

export const TAB_STYLE_OVERRIDES = {
  "& .MuiTab-root .MuiTypography-root": {
    fontSize: "1.125rem",
    fontWeight: 500,
  },
  "& .MuiTabs-root": { padding: 0 },
  "& .MuiTab-root": { padding: 0 },
};

export const UpsellContentContainer = styled(CarouselPanel)({
  alignItems: "center",
  justifyContent: "center",
  flex: 1,
  width: "100%",
  maxHeight: "100%",
  backgroundImage: `url(${UpsellHeroBg})`,
  backgroundPosition: "top",
  backgroundSize: "cover",
  position: "relative",
  padding: "40px",
});

export const UpsellPanelTitle = styled(Typography)({
  fontWeight: 500,
  fontSize: "2rem",
  color: "#fff",
  textAlign: "center",
});

export const UpsellImageContainer = styled(Stack)({
  overflow: "hidden",
  position: "relative",
  flexShrink: 1,
});
